<template>
  <div class="packing-order">
    <div>
      <div class="avatar">
        <img :src="userInfo.logo_url || require('../../assets/logo.png')" alt="">
      </div>
      <div class="info">
        <div class="userName">{{userInfo.name || '无'}}</div>
        <div>
          <span class="label">柜柜账号</span>
          <span>：{{userInfo.phone || '无'}}</span>
        </div>
        <div>
          <span class="label">地址</span>
          <span>：{{userInfo.address || '无'}}</span>
        </div>
        <div>
          <span class="label">柜柜钱包</span>
          <span>：{{userInfo.wallet}}元</span>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState([
      'userInfo'
    ]),
  }
}
</script>

<style scoped lang="less">
span{
  font-size: 14px;
}
.avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
}
.info {
  margin-left: 30px;
  text-align: left;
  > div:not(:last-child) {
    margin-bottom: 10px;
  }
  span.label {
    text-align: justify;
    width: 4em;
  }
}
.packing-order {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 750px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 6px 6px 15px rgba(146, 146, 146, 0.16);
  padding: 40px;
  > div {
    display: flex;
    align-items: center;
  }
}
</style>